export const DEFAULT_LOCALE = 'en-us';
export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_CURRENCY_CODE = 'USD';
export const NEXT_LOCALE_COOKIE_NAME = 'NEXT_LOCALE';
export const SNEAKER_LOCALE_COOKIE_NAME = 'locale';

export enum LOCALES {
  enUS = 'en-us',
  enGB = 'en-gb',
  enCA = 'en-ca',
  enAU = 'en-au',
  frFR = 'fr-fr',
  enIT = 'en-it',
  enNL = 'en-nl',
}

export const AVAILABLE_LOCALES = {
  [LOCALES.enUS]: {
    code: LOCALES.enUS,
    currency: 'USD',
    country: 'US',
    countryName: 'United States',
    label: 'English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enGB]: {
    code: LOCALES.enGB,
    currency: 'GBP',
    country: 'UK',
    countryName: 'United Kingdom',
    label: 'United Kingdom English',
    showVAT: true,
    locale: 'en',
  },
  [LOCALES.enCA]: {
    code: LOCALES.enCA,
    currency: 'CAD',
    country: 'CA',
    countryName: 'Canada',
    label: 'Canada English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enAU]: {
    code: LOCALES.enAU,
    currency: 'AUD',
    country: 'AU',
    countryName: 'Australia',
    label: 'Australia English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.frFR]: {
    code: LOCALES.frFR,
    currency: 'EUR',
    country: 'FR',
    countryName: 'France',
    label: 'French',
    showVAT: false,
    locale: 'fr',
  },
  [LOCALES.enNL]: {
    code: LOCALES.enNL,
    currency: 'EUR',
    country: 'NL',
    countryName: 'Netherlands',
    label: 'Netherlands English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enIT]: {
    code: LOCALES.enIT,
    currency: 'EUR',
    country: 'IT',
    countryName: 'Italy',
    label: 'Italy English',
    showVAT: false,
    locale: 'en',
  },
};

export const AVAILABLE_LANGUAGES = Object.values(AVAILABLE_LOCALES).map((locale) => {
  return {
    code: locale.code,
    label: locale.label,
  };
});

export const COUNTRY_TO_LOCALE_MAP: { [key: string]: string } = {
  US: LOCALES.enUS,
  UK: LOCALES.enGB,
  GB: LOCALES.enGB,
  CA: LOCALES.enCA,
  AU: LOCALES.enAU,
  NL: LOCALES.enNL,
  IT: LOCALES.enIT,
};
